import { toExponentialUppercase } from "@app/utils/functions";
import { transpose, pow, multiply, lusolve, mean } from "mathjs";

export const recalcularCoeficientes = (puntos) => {
  const A: number[][] = [];
  const B: number[] = [];
  const filteredPuntos = puntos
    .filter((punto) => punto.x !== 0 && punto.y !== 0)
    .map((punto) => ({
      x: punto.x,
      y: Number(punto.y.toFixed(8)),
    }));

  filteredPuntos.forEach((punto) => {
    const x = punto.x;
    const y = punto.y;
    A.push([pow(x, 2), x, 1]);
    B.push(y);
  });

  const B_vector = transpose([B]);
  const AT = transpose(A);
  const ATA = multiply(AT, A);
  const ATB = multiply(AT, B_vector);
  const coeficientesNumericos = lusolve(ATA, ATB);

  const r2 = calcularR2(filteredPuntos, coeficientesNumericos);

  const coeficientesFormateados = coeficientesNumericos.map((coef) =>
    toExponentialUppercase(coef[0], 8)
  );

  return { coeficientesNumericos, coeficientesFormateados, r2 };
};

export const calcularR2 = (puntos, coeficientes) => {
  const [a, b, c] = coeficientes;

  const polinomio = (x) => a[0] * Math.pow(x, 2) + b[0] * x + c[0];

  const mediaY = mean(puntos.map((p) => p.y));

  const ssTot = puntos.reduce((sum, punto) => {
    return sum + Math.pow(punto.y - mediaY, 2);
  }, 0);

  const ssRes = puntos.reduce((sum, punto) => {
    return sum + Math.pow(punto.y - polinomio(punto.x), 2);
  }, 0);

  return 1 - ssRes / ssTot;
};

export function calcularU2relFa(rows, coeficientes) {
  let n = 0;
  for (var i = 0; i < rows.length; i++)
    n = rows[i].fa_exp > 0 && rows[i].fc_calc > 0 ? n + 1 : n;
  if (n <= 1) return NaN;

  const sumatoria = rows.reduce((sum, row) => {
    const faExp = row.fa_exp.toFixed(8);
    const faCalc = row.fc_calc.toFixed(8);

    // Validar que faExp no sea cero para evitar divisiones por cero
    if (faExp === 0 || isNaN(faExp) || isNaN(faCalc)) {
      return sum;
    }

    const diffSquared = Math.pow((faExp - faCalc) / faExp, 2);
    if (isNaN(diffSquared)) return sum;

    return sum + diffSquared;
  }, 0);

  // Calcular la incertidumbre relativa
  const u2relFa = (1 / (n - 1)) * sumatoria;

  // Asegurarse de que el resultado sea un número válido
  return isNaN(u2relFa) ? NaN : toExponentialUppercase(u2relFa, 4);
}
